<template>
	<div class="errPage-container">
		<el-button icon="arrow-left" class="pan-back-btn" @click="back">返回</el-button>
		<el-row>
			<el-col :span="12">
				<h1 class="text-jumbo text-ginormous">401错误!</h1>
				<h2>您没有访问权限！</h2>
				<h6>对不起，您没有访问权限，请不要进行非法操作！您可以返回主页面</h6>
				<ul class="list-unstyled">
					<li class="link-type">
						<router-link to="/">回登录页</router-link>
					</li>
				</ul>
			</el-col>
			<el-col :span="12">
				<img :src="errGif" width="313" height="428" alt="Girl has dropped her ice cream." />
			</el-col>
		</el-row>
	</div>
</template>

<script>
import errGif from "@/assets/401_images/401.gif";

export default {
	name: "Page401",
	data() {
		return {
			errGif: errGif + "?" + +new Date()
		};
	},
	methods: {
		back() {
			// 关闭当前页
			if (this.$tabs && typeof this.$tabs.close === "function") {
				// 使用vue-router-tab提供的API关闭当前标签页
				this.$tabs.close();
			} else {
				// 如果没有标签页API，降级到跳转到工作台页面
				this.$router.push({
					path: "/exeIndex/mainIndex/workbench"
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.errPage-container {
	width: 960px;
	max-width: 100%;
	margin: 0 auto;
	min-height: 100vh;
	padding: 72px 24px;
	box-sizing: border-box;
	display: flex;
	align-items: center;

	.pan-back-btn {
		background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%);
		color: #fff;
		border: none !important;
		border-radius: 8px;
	}

	.pan-gif {
		margin: 0 auto;
		display: block;
	}

	.pan-img {
		display: block;
		margin: 0 auto;
		width: 100%;
	}

	.text-jumbo {
		font-size: 60px;
		font-weight: 700;
		color: #0f172a;
	}

	.list-unstyled {
		font-size: 14px;

		li {
			padding-bottom: 5px;
		}

		a {
			color: #1d4ed8;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}
	}
}
</style>
